// extracted by mini-css-extract-plugin
module.exports = {"priceTable":"styles_priceTable__1hNsk","active":"styles_active__18kx7","activeMonth":"styles_activeMonth__1d0Wl","caption":"styles_caption__1Fko_"};